module.exports = __webpack_public_path__ + "static/media/img3.39e93bdd.png";